// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_QVw02","logoLink":"index_logoLink_JeLbY","breadcrumbs":"index_breadcrumbs_n-K8h"};